import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	tagsContainer: {
		display         : "flex",
		justifyContent  : "center",
		padding         : "2rem",
		backgroundColor : theme.other.colors.background.tertiary,
		borderRadius    : "24px",
		flexDirection   : "column",
		gap             : "2rem",
		alignItems      : "flex-start"
	},
	tagName: {
		// width           : "31%",
		borderRadius    : "24px",
		// border          : "1px solid",
		// borderColor     : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryLightGrey,
		color           : theme.other.colors.text.primary,
		textAlign       : "center",
		padding         : "0.5rem 1.5rem",
		fontSize        : "1.3rem",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey20 : theme.other.paletteNew.secondaryBackgroundGrey
		// cursor          : "pointer"
	},
	tagsInnerContainer: {
		display  : "flex",
		gap      : "1rem",
		flexWrap : "wrap",
		width    : "100%"
	},
	tagsHeading: {
		fontSize: "1.7rem"
	}
} ) );
